import * as React from "react";
import {navigate} from "gatsby-link";
import {useDispatch} from "react-redux";
import {Util , Navbar} from "baziigram"
import {STORAGE_KEY} from "../../constants";
import {useEffect, useState} from "react";
import {showLoginDialog} from "../../pages/Login"
import {useSelector} from "react-redux";
import {dictionary} from "../../constants"
import {GetUser} from "../../Util/user"
const GameNavbar = ({links, page , backUrl="/"}) => {
    const [location,setLocation] = useState("home")

     const [menus,setMenus] = useState([])
     const [mute,setMute] = useState(false)
     const [language,setLanguage] = useState("en")

        useEffect(()=>{
        let user = GetUser();
        setLanguage(Util.getLanguage())
        if(page == "webView")
        { setMenus([])
        return
        }
          if(user && user.accessToken )
          setMenus([{title:dictionary.profile[language],logo:`/images/profileImages/${user.logo}.png`, action:()=>navigate("/UserProfile")},
          {title:dictionary.prize[language],logo:"/images/icons/giftIcon.png", action:()=>navigate("/Awards")},
          ])

          else
          setMenus([{title:dictionary.login[language], action:()=>showLoginDialog()},
          {title:dictionary.prize[language],logo:"/images/icons/giftIcon.png", action:()=>navigate("/Awards")},
          ])
        },[language])


        useEffect(()=>{
        try{
        document.getElementsByName('baziigramFrame')[0].contentWindow.postMessage({message:"handleVoice",mute},"https://games.baziigram.com")
        document.getElementsByName('baziigramFrame')[0].contentWindow.postMessage({message:"handleVoice",mute},"https://levels.baziigram.com")
        }
        catch(err){}
        },[mute])



    return (
         <Navbar menus={menus} page={page}>
         <button lang={language} className={"m-0 p-0 btn-left"}
         onClick={() => {
         window.dispatchEvent(new CustomEvent("back-is-clicked"));
         navigate(backUrl)}
         }>
             {page=="home" && <img  src="/images/main-page/logo.png" height={"50px"}/>}
             {page!="home" &&   <img className={"p-0 m-0 btn-left"} src="/images/icons/backBtn.png" height={"40px"}/>}
         </button>
       {page!="home" &&   <button style={{display:'none'}} id="mute-btn" lang={language} className={"m-0 p-0 btn-right"}
           onClick={()=>setMute(!mute)}>
            <img className={"p-0 m-0 btn-right"} src={`/images/icons/${mute==false ? "unmute.png" : "mute.png"}`} height={"40px"}/>
           </button>}
         </Navbar>
    );
};
GameNavbar.defaultProps = {
    backUrl:"/"
};
export default GameNavbar;
